import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import createMarkup from '../../../_utils/murkup';
import { SHOP_TYPES } from '../../../config';
import SpoilerInfo from '../common/SpoilerInfo.jsx';
import { getFormInfo } from '../../actions/shop';


class OffersFormInfo extends React.Component {
  static propTypes = {
    formInfo: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  };

  componentDidMount() {
    try{
      if (SHOP_TYPES[this.props.type]['infoName']) {
        this.props.getFormInfo(SHOP_TYPES[this.props.type]['infoName'] + this.props.lang);
      }
    } catch (e) { }
  }
  render() {
    if (this.props.formInfo){
      return <SpoilerInfo>
        <div dangerouslySetInnerHTML={ createMarkup(this.props.formInfo) }></div>
      </SpoilerInfo>;
    }
    return <></>;
  }
}

let mapStateToProps = (state) => {
  return {
    formInfo: state.shop.formInfo,
    lang: state.auth.lang,
  }
};
export default compose(connect(mapStateToProps, { getFormInfo }))(OffersFormInfo);
